import type { i18n as I18n } from "i18next";
import en from "@/locales/en/games/falling-blocks.json";
import fr from "@/locales/fr/games/falling-blocks.json";

export const FALLING_BLOCKS_NS = "games/falling-blocks";

/** Adds this game's translations to an initialised i18next instance (idempotent). */
export function registerFallingBlocksTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", FALLING_BLOCKS_NS))
    i18n.addResourceBundle("en", FALLING_BLOCKS_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", FALLING_BLOCKS_NS))
    i18n.addResourceBundle("fr", FALLING_BLOCKS_NS, fr, true, true);
}
